<template>
  <div class="body-content">
    <navbar :title="$t('basic.navText')" back="true"></navbar>
    <div class="account-wrapper">
      <div class="slogan-wrapper">
        <span class="slogan-text">{{ $t('basic.updatePwd') }}</span>
      </div>
      <div class="account-form">
        <div class="form-row">
          <input type="password" class="form-input" :placeholder="$t('basic.oldPwd')" v-model='oldPwd'
                 v-bind:class="{ 'input-require': oldPwdValidate.invalidate }" @keyup.enter="resetPwd">
          <p class="text-error" v-if="oldPwdValidate.emtpy">{{ $t('basic.oldPwdInput') }}</p>
          <p class="text-error" v-if="oldPwdValidate.error">{{ $t('basic.oldPwdInvalidate') }}</p>
          <p class="text-error" v-if="loginResult.fail">{{ $t('basic.notExist') }}</p>
          <p class="text-error" v-if="oldPwdValidate.format">{{ $t('register.password_set') }}</p>
        </div>
        <div class="form-row">
          <input type="password" class="form-input" :placeholder="$t('basic.newPwd')" v-model='newPwd'
                 v-bind:class="{ 'input-require': newPwdValidate.invalidate }" @keyup.enter="resetPwd">
          <p class="text-error" v-if="newPwdValidate.emtpy">{{ $t('basic.newPwdInput') }}</p>
          <p class="text-error" v-if="newPwdValidate.same">{{ $t('basic.notSame') }}</p>
          <p class="text-error" v-if="newPwdValidate.format">{{ $t('register.password_set') }}</p>
        </div>
        <div class="form-row">
          <input type="password" class="form-input" :placeholder="$t('basic.confirmPwd')" v-model='confirmPwd'
                 v-bind:class="{ 'input-require': confirmPwdValidate.invalidate }" @keyup.enter="resetPwd">
          <p class="text-error" v-if="confirmPwdValidate.emtpy">{{ $t('basic.confirmPwdInput') }}</p>
          <p class="text-error" v-if="confirmPwdValidate.same">{{ $t('basic.notSameWith') }}</p>
          <p class="text-error" v-if="confirmPwdValidate.format">{{ $t('register.password_set') }}</p>
        </div>
        <div class="form-row btn-wrap">
          <p class="text-error" :class="{lang: lang === 'en' || lang === 'ru_RU'}">{{ low ? $t('basic.lowPw') : '' }}</p>
          <button class="czur-style" type="button" @click='resetPwd'>{{ $t('basic.Submit') }}</button>
        </div>
      </div>
      <loading :appear="processing"></loading>
    </div>
    <LoginCheck v-on:nologin="withOutLogin"></LoginCheck>
  </div>
</template>
<script>
import Config from 'common/script/config.js'
import Validate from 'common/script/validate.js'
import loading from 'components/loading/loading'
import MD5 from 'common/script/md5.js'
import navbar from 'components/nav/nav'
import LoginCheck from 'components/loginCheck/loginCheck'

export default {
  name: 'resetPwd',
  props: ['lang'],
  data () {
    return {
      low: false,
      oldPwd: '',
      newPwd: '',
      confirmPwd: '',
      oldPwdValidate: {
        emtpy: false,
        invalidate: false,
        error: false,
        format: false
      },
      newPwdValidate: {
        emtpy: false,
        invalidate: false,
        same: false,
        format: false
      },
      confirmPwdValidate: {
        emtpy: false,
        invalidate: false,
        same: false,
        format: false
      },
      loginResult: {
        fail: false
      },
      processing: false
    }
  },
  components: {
    loading,
    navbar,
    LoginCheck
  },
  methods: {
    withOutLogin: function (argument) {
      window.location.href = '/index.html'
    },
    oldPwdCheck: function () {
      if (Validate.stringEmpty(this.oldPwd)) {
        this.oldPwdValidate.emtpy = true
        this.oldPwdValidate.format = false
        this.oldPwdValidate.error = false
        this.oldPwdValidate.invalidate = true
      } else if (this.oldPwd.length < 6) {
        this.oldPwdValidate.emtpy = false
        this.oldPwdValidate.format = false
        this.oldPwdValidate.error = true
        this.oldPwdValidate.invalidate = true
      } else if (!Validate.passwordRuleLow(this.oldPwd)) {
        this.oldPwdValidate.emtpy = false
        this.oldPwdValidate.invalidate = true
        this.oldPwdValidate.error = false
        this.oldPwdValidate.format = true
      } else {
        this.oldPwdValidate.emtpy = false
        this.oldPwdValidate.invalidate = false
        this.oldPwdValidate.format = false
        this.oldPwdValidate.error = false
      }
    },
    newPwdCheck: function () {
      if (Validate.stringEmpty(this.newPwd)) {
        this.newPwdValidate.emtpy = true
        this.newPwdValidate.invalidate = true
      } else if (!Validate.passwordRule(this.newPwd)) {
        this.newPwdValidate.emtpy = false
        this.newPwdValidate.invalidate = true
        this.newPwdValidate.format = true
      } else if (this.newPwd === this.oldPwd) {
        this.newPwdValidate.same = true
        this.newPwdValidate.emtpy = false
        this.newPwdValidate.invalidate = true
      } else {
        this.newPwdValidate.emtpy = false
        this.newPwdValidate.same = false
        this.newPwdValidate.invalidate = false
      }
    },
    confirmPwdCheck: function () {
      if (Validate.stringEmpty(this.confirmPwd)) {
        this.confirmPwdValidate.emtpy = true
        this.confirmPwdValidate.invalidate = true
      } else if (!Validate.passwordRule(this.newPwd)) {
        this.confirmPwdValidate.emtpy = false
        this.confirmPwdValidate.invalidate = true
        this.confirmPwdValidate.format = true
      } else if (this.confirmPwd !== this.newPwd) {
        this.confirmPwdValidate.same = true
        this.confirmPwdValidate.emtpy = false
        this.confirmPwdValidate.invalidate = true
      } else {
        this.confirmPwdValidate.emtpy = false
        this.confirmPwdValidate.invalidate = false
        this.confirmPwdValidate.same = false
      }
    },
    formCheck: function () {
      this.oldPwdCheck()
      this.newPwdCheck()
      this.confirmPwdCheck()
      return this.oldPwdValidate.invalidate || this.newPwdValidate.invalidate || this.confirmPwdValidate.invalidate
    },
    resetPwd: function () {
      if (!this.formCheck()) {
        this.processing = true
        this.$http.post(Config.passportHost + '/account/pwd/reset/', {
          'u_id': Config.cookieGet(Config.COOKIE_KEY.U_ID),
          'o_pwd': MD5.hex_md5(this.oldPwd),
          'n_pwd': MD5.hex_md5(this.newPwd)
        }).then((response) => {
          this.processing = false
          response = response.body
          if (response.code !== Config.R_CODE.SUCCESS) {
            if (response.code === 1031) {
              this.oldPwdValidate.error = true
            } else if (response.code === Config.USER_NO_EXIST) {
              this.loginResult.fail = true
            }
          } else if (response.code === Config.R_CODE.SUCCESS) {
            Config.setLocalStore('pw', 0)
            this.$router.push({path: '/updateSuccess' + (this.low ? '/low' : '')})
          }
        })
      }
    }
  },
  created: function () {
    this.low = this.$route.params.type === 'low'
    Config.setLocalStore('request_flag', 0)
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.text-error
  min-height 0.16rem !important
  line-height 0.16rem !important

#login .account-form .form-row.btn-wrap
  margin-top 0rem !important

  .text-error
    text-align center
    line-height 0.44rem !important
    &.lang
      line-height 0.18rem !important
      margin-bottom 0.08rem
</style>



// WEBPACK FOOTER //
// resetPwd.vue?70147f0c